import * as React from "react";
import { useEffect } from "react";

/**
 * 縦横の列挙型
 */
export enum OrientationEnum {
	"portrait",
	"landscape"
}

export interface IResizeValue {
	width:number,
	height:number
}

/**
 * 縦横の取得
 */
function getOrientation() {
	return window.innerWidth > window.innerHeight ?
		OrientationEnum.landscape :
		OrientationEnum.portrait;
}

export const OrientationContext = React.createContext<{ orientation: OrientationEnum, resize: IResizeValue }>(
	{
		orientation: OrientationEnum.landscape,
		resize: {
			width: window.innerWidth,
			height: window.innerHeight
		}
	}
);

export const OrientationProvider: React.FC<{ children: React.ReactNode }> = ( { children } ) => {

	const [orientation, setOrientation] = React.useState( getOrientation() );
	const [resize, doResize] = React.useState( {
		width: window.innerWidth,
		height: window.innerHeight
	} );

	// 縦横変更イベントハンドラ
	// 1. 表示ブラウザのリサイズ時（PC用）
	// 2. スマホの縦横切り替え時（スマホ、タブレット用）
	const handleOrientationChange = () => {
		setOrientation(
			getOrientation()
		);
	};

	// 初回のみ実行
	useEffect( () => {
		// 縦横チェンジイベントハンドラ
		window.onorientationchange = () => {
			handleOrientationChange();
		};

		let timer = -1;
		// リサイズイベントハンドラ
		const resizeFunc = () => {
			if ( timer > 0 ) {
				clearTimeout( timer );
			}

			timer = window.setTimeout( () => {
				handleOrientationChange();
				doResize( {
					width: window.innerWidth,
					height: window.innerHeight
				} );
				timer = -1;
			}, 200 );
		};

		window.addEventListener( "resize", resizeFunc );

		return () => {
			window.removeEventListener( "resize", resizeFunc );
		};
	}, [] );

	return (
		<OrientationContext.Provider value={{
			orientation,
			resize
		}}>
			{children}
		</OrientationContext.Provider>
	);
};